import PropTypes from "prop-types";

import ClassroomSyncModal from "./ClassroomSyncModal";

const propTypes = {
  modalProps: PropTypes.shape({
    isActive: PropTypes.bool,
  }).isRequired,
};

const ClassroomSyncModalIndex = (props) => {
  const { isActive } = props.modalProps;
  if (isActive) return <ClassroomSyncModal {...props} />;
};

ClassroomSyncModalIndex.propTypes = propTypes;

export default ClassroomSyncModalIndex;
